<ng-container [formGroup]="filePickerFormGroup">
  <div class="coverall" *ngIf="throwOverlay"></div>
  <div class="coversome" *ngIf="!isEditable"></div>
  <div class="filepicker-wrapper" dnd (fileDropped)="prepareFiles($event)">
    <div class="dropzone" (change)="fileBrowseHandler($event.target.files)" [ngClass]="{'disabled': !isEditable}">
      <i class="fas fa-upload"></i>
      <label for="{{question.QuestionName}}" class="visually-hidden">File</label>
      <input type="file"
        class="form-control"
        #filepicker
        accept=".pdf"
        id="{{question.QuestionName}}"
        tabindex="0" [ngClass]="{'disabled': !isEditable}" formControlName="Upload" #file>
      <p class="d-none d-md-block" style="font-weight:500">Drag and drop file here</p>
      <p class="d-none d-md-block" style="font-weight:500">or</p>
      <div class="last"></div>
      <label for="file" (click)="file.click()" onkeypress="file.click()" [ngClass]="{'input-required': isRequired && isEditable}">Browse for file</label>
    </div>
      <p class="oops" [ngClass]="{'show': oopsMsg}">{{ oopsMsg }}</p>
      <div class="files-list">
        <div class="single-file" *ngFor="let file of illustrationFiles; let i = index">
          <div class="file-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3800 4800">
              <g><path fill="#EEE" d="M0 4800h3800V840L2960 0H0"/><path fill="#BBB" d="M2960 840h840L2960 0"/><path fill="#888" d="M3800 1680V840h-840"/></g>
              <g><path fill="#555" d="M900 1976h2000v-212H900m0 670h2000v-211H900m0 670h2000v-212H900m0 635h1200v-176H900"/></g>
            </svg>
          </div>
          <div class="info">
            <p class="name" style="margin-top: 0px !important;">
              {{ file?.name }}
            </p>
            <p class="size">
              {{ formatBytes(file?.size) }}
            </p>
            <div class="progress-cont animate">
              <span></span>
              <div class="progress" [style.width]="file?.progress + '%'">
              </div>
            </div>
          </div>
          <div class="delete" (click)="deleteFile(i)" onkeypress="deleteFile(i)" *ngIf="isEditable">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
              <path fill="#B1B1B1" fill-rule="nonzero"
                d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
            </svg>
          </div>
        </div>
      </div>
  </div>
</ng-container>
